import { render, staticRenderFns } from "./pesoParaLaTallaNinos0a2A.vue?vue&type=template&id=62a5bf39&scoped=true"
import script from "./pesoParaLaTallaNinos0a2A.vue?vue&type=script&lang=js"
export * from "./pesoParaLaTallaNinos0a2A.vue?vue&type=script&lang=js"
import style0 from "./pesoParaLaTallaNinos0a2A.vue?vue&type=style&index=0&id=62a5bf39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a5bf39",
  null
  
)

export default component.exports